/**
 * Rename mapping for instruments based on workcell ID.
 * @param workcellId
 * @returns Dictionary mapping original instrument IDs to the new one.
 */
export const useGetInstrumentsRenameMapping = (
  workcellId: string
): Record<string, string> => {
  const renameMapping: Record<string, Record<string, string>> = {
    azProd: {
      agilent_lhc: 'biotek',
    },
  };

  return renameMapping[workcellId] || {};
};
